import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormField } from '../../../common/models/form-details.model';
import { FormControl, FormGroup } from '@angular/forms';
import { WS10Checkbox, WS10CheckboxItem } from '@vfde-fe/ngx-lib/brix/ws10-form-checkbox';

/** CheckboxComponent */
@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CheckboxComponent implements OnInit {
  /** formField */
  @Input() public formField: FormField;

  /** form */
  @Input() public form: FormGroup;

  /** checkboxModel */
  public checkboxModel: WS10Checkbox;

  /** formControlName */
  public formControlName: string;

  /** ngOnInit */
  public ngOnInit (): void {
    if (this.formField) {
      this.configureComponent(this.formField);
    }
  }
  /** configureComponent
   * @method configureComponent
   * @param {FormField} data
   */
  public configureComponent (data: FormField) {
    if (data && data.name  && data.label) {
      const blockId = `block-id-${data.id}`;
      this.formControlName = data.name;

      /** construct check boxes */
      const checkboxes = new Array<WS10CheckboxItem>();
      checkboxes.push({
        label: data.label,
        checkboxValue: data.label,
        id: `checkbox-${data.id}`,
        isChecked: data.value === data.label ? true : false,
      });
      this.checkboxModel = {
        items: checkboxes,
        id: blockId,
      };
      this.form.addControl(data.name, new FormControl(data.value));
    }

  }
}
